

<template>
  <!-- component -->

  <div class="md:mx-auto mb-4" v-if="serieData">
    <HomeLayout :data="true">
      <trailler-view
        :asset="serieData"
        :firstEposide="firstEposide"
        :isLaoding="isLaoding"
      />
    </HomeLayout>

    <div v-show="!isLaoding" class="flex flex-wrap my-3 md:mx-12" dir="rtl">
      <horizental-view
        v-for="(item, index) in serieData.eposides"
        :key="item.id"
        :item="item"
        :index="index"
        :image="serieData.eposides.image"
      />
    </div>

    <SpinnerView :isLoading="isLaoding" />
  </div>
</template>
<script>
import HomeLayout from "@/components/HomeLayout.vue";
import TraillerView from "@/components/cards/TraillerView.vue";
import { mapActions, mapState } from "pinia";
import SpinnerView from "@/components/SpinnerView.vue";
import { useSerieStore } from "@/stores/serie";
import HorizentalView from "@/components/cards/HorizentalView.vue";

export default {
  components: {
    HomeLayout,
    TraillerView,
    SpinnerView,
    HorizentalView,
  },
  data() {
    return {
      isLaoding: false,
    };
  },

  computed: {
    ...mapState(useSerieStore, ["firstEposide", "serieData", "getEposides"]),
    // sortedd() {
    //   return this.serieData.eposides.slice().sort((a, b) => {
    //     return -(b.order - a.order);
    //   });
    // },
  },
  methods: {
    ...mapActions(useSerieStore, ["ShowSerieData"]),
  },
  async created() {
    this.isLoading = true;
    try {
      await this.ShowSerieData(this.$route.params.id);

      setTimeout(() => {
        this.isLaoding = false;
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        this.isLaoding = false;
      }, 1000);
      console.error("Failed to grab portal data", error);
    }
  },
};
</script>

<style>
</style>

